import type { HTMLAttributes } from "react";
import { Icon } from "./Icon";
import "./reason.css";

type Props = HTMLAttributes<HTMLParagraphElement> & { tone?: "info" | "warning" };

// Il motivo scritto e sempre visibile di un controllo spento o di una schermata in sola lettura
// (UX_SYSTEM: il solo `title` non basta). Ha un `id` da mettere in `aria-describedby` del controllo.
export function Reason({ tone = "info", className, children, ...rest }: Props) {
  return (
    <p className={className ? `g-reason ${className}` : "g-reason"} data-tone={tone} {...rest}>
      <Icon name={tone === "warning" ? "alert" : "info"} />
      <span>{children}</span>
    </p>
  );
}
